function redirectHome(): void {
  window.location.href = '/'
}

export default redirectHome
